// ==============================|| LOGO IMAGE ||============================== //

import vrpLogo from 'assets/images/users/logovrp1.png';
import iberdrolaLogo from 'assets/images/users/logoiberdrola.png';

function resolveArea() {
  try {
    const p = typeof window !== 'undefined' ? window.location?.pathname || '' : '';
    if (p.startsWith('/i')) return 'i';
    if (p.startsWith('/v')) return 'v';
  } catch {}
  try {
    const a = localStorage.getItem('current_area');
    if (a === 'i' || a === 'v') return a;
  } catch {}
  return 'v';
}

export default function LogoMain() {
  const area = resolveArea();
  const logo = area === 'i' ? iberdrolaLogo : vrpLogo;
  return (
    <img
      src={logo}
      alt="Logo"
      style={{
        height: '50px',
        width: 'auto',
        objectFit: 'contain',
        display: 'block',
        margin: '20px auto 0 auto',
        borderRadius: area === 'i' ? 8 : undefined
      }}
    />
  );
}
